import { useState, useCallback } from 'react';

interface FirebaseErrorState {
  isError: boolean;
  errorMessage: string;
}

export const useFirebaseError = () => {
  const [errorState, setErrorState] = useState<FirebaseErrorState>({
    isError: false,
    errorMessage: ''
  });

  const showError = useCallback((message?: string) => {
    setErrorState({
      isError: true,
      errorMessage: message || '데이터를 불러오는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'
    });
  }, []);

  const hideError = useCallback(() => {
    setErrorState({
      isError: false,
      errorMessage: ''
    });
  }, []);

  const handleFirebaseError = useCallback((error: any, customMessage?: string) => {
    console.error('Firebase 에러:', error);
    
    let errorMessage = customMessage;
    
    if (!errorMessage) {
      // Firebase 에러 코드에 따른 메시지 설정
      if (error.code) {
        switch (error.code) {
          case 'unavailable':
            errorMessage = '서버에 연결할 수 없습니다. 네트워크를 확인해주세요.';
            break;
          case 'deadline-exceeded':
            errorMessage = '요청 시간이 초과되었습니다. 다시 시도해주세요.';
            break;
          case 'permission-denied':
            errorMessage = '접근 권한이 없습니다.';
            break;
          case 'not-found':
            errorMessage = '요청한 데이터를 찾을 수 없습니다.';
            break;
          case 'already-exists':
            errorMessage = '이미 존재하는 데이터입니다.';
            break;
          case 'resource-exhausted':
            errorMessage = '서버 리소스가 부족합니다. 잠시 후 다시 시도해주세요.';
            break;
          case 'failed-precondition':
            errorMessage = '요청 조건이 맞지 않습니다.';
            break;
          case 'aborted':
            errorMessage = '요청이 중단되었습니다. 다시 시도해주세요.';
            break;
          case 'out-of-range':
            errorMessage = '요청 범위를 벗어났습니다.';
            break;
          case 'unimplemented':
            errorMessage = '지원하지 않는 기능입니다.';
            break;
          case 'internal':
            errorMessage = '서버 내부 오류가 발생했습니다.';
            break;
          case 'unauthenticated':
            errorMessage = '인증이 필요합니다.';
            break;
          default:
            errorMessage = '데이터를 불러오는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
        }
      } else {
        errorMessage = '데이터를 불러오는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
      }
    }
    
    showError(errorMessage);
  }, [showError]);

  return {
    errorState,
    showError,
    hideError,
    handleFirebaseError
  };
};
